import { CHATWOOT_BASE, authHeaders } from '@/api/chatwoot'

const ACCOUNT_PATH = `${CHATWOOT_BASE}/api/v1/accounts/3`

export interface SnoozeResult {
  status: string
  snoozedUntil: number | null
}

/**
 * Adia uma conversa. `until` é o epoch (segundos) de retomada, ou null
 * para "até a próxima resposta do cliente" (usado também pela ação de
 * macro `snooze_conversation`, que nunca define um prazo).
 */
export async function snoozeConversation(convId: number, token: string, until: number | null = null): Promise<SnoozeResult> {
  const body: Record<string, unknown> = { status: 'snoozed' }
  if (until !== null) body.snoozed_until = until

  const res = await fetch(`${ACCOUNT_PATH}/conversations/${convId}/toggle_status`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders(token) },
    body: JSON.stringify(body),
  })
  if (!res.ok) throw new Error(`Snooze error ${res.status}`)
  const data = await res.json()
  return { status: data.current_status ?? 'snoozed', snoozedUntil: until }
}
